export const initialDataConfigConcept = () => {
    return {
        'id': null,
        'company_id': null,
        'updated_date': '',
        'information_analysis': '',
        'conclusions': ''
    };
};

export default {
    configConcept: initialDataConfigConcept(),
};
